import SettingsScreen from "@/features/menu/SettingsScreen";

export default function Settings() {
    return <SettingsScreen />;
}
